"use client"

import * as React from "react"
import { TrendingDown, TrendingUp } from "lucide-react"
import { Label, Pie, PieChart } from "recharts"

import {
    Card,
    CardContent,
    CardDescription,
    CardFooter,
    CardHeader,
    CardTitle,
} from "../../components/ui/Card"
import {
    ChartContainer,
    ChartTooltip,
    ChartTooltipContent,
} from "../../components/ui/chart"
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
  } from "../../components/ui/Select"

export function ShadDonutTextChart({ deviceNames, donutDeviceName, setDonutDeviceName, currentWeekValue, chartConfig, weeklyDifference, desktopData, chartDescription, differenceIsPercent }) {
    // console.log(deviceNames, data, data.length,desktopData[desktopData.length-1].desktop, "deviceNames");
    
    // const dateRangeSundays = eachWeekOfInterval({
    //     start: new Date(data[0]?.date),
    //     end: new Date(data[data.length-1]?.date)
    // });

    // let lastSundayDate = dateRangeSundays[dateRangeSundays.length-2];
    // let lastToLastSundayDate = dateRangeSundays[dateRangeSundays.length-3];
    // let lastSaturdayDate = subDays(dateRangeSundays[dateRangeSundays.length-1],1);
    // let lastToLastSaturdayDate = subDays(dateRangeSundays[dateRangeSundays.length-2],1);

    // // debugger;

    // // console.time("donutDataMes");

    // const result = data.reduce((acc, curr) => {
    //     const dateOnly = curr.date.split("T")[0]; // Extract the date part (YYYY-MM-DD)
    //     acc[dateOnly] = (acc[dateOnly] || 0) + curr.entering; // Sum up "entering"
    //     return acc;
    // }, {});

    // console.log(result, "resulta");
    


    // const formattedResult = Object.entries(result).map(([date, enteringSum]) => ({
    //     date,
    //     enteringSum
    // }));

    // console.log(formattedResult,formattedResult.length, "result");

    
    // formattedResult.slice(formattedResult.findIndex(fr=>new Date(fr.date).getDate() === new Date(lastSundayDate).getDate()),formattedResult.findIndex(fr=>new Date(fr.date).getDate() === new Date(addDays(lastSaturdayDate,1)).getDate())).forEach((element, i) => {
    //     desktopData[i].month = new Date(element.date).toLocaleString('he-us', { day: 'numeric', month: 'short', weekday: 'short' });
    //     desktopData[i].desktop = element.enteringSum;
    // });
    
    // const currentWeekValue = desktopData.reduce((acc, item) => acc + item.desktop, 0);
    // const lastWeekValue = formattedResult.slice(formattedResult.findIndex(fr=>new Date(fr.date).getDate() === new Date(lastToLastSundayDate).getDate()),formattedResult.findIndex(fr=>new Date(fr.date).getDate() === new Date(addDays(lastToLastSaturdayDate,1)).getDate())).reduce((acc, item) => acc + item.enteringSum, 0);
    // const weeklyDifference = currentWeekValue - lastWeekValue;
    // // debugger;
    // console.log(desktopData,lastWeekValue,currentWeekValue, "desktopData");

    // // console.timeEnd("donutDataMes");

    // const id = "pie-interactive"
    // const [activeMonth, setActiveMonth] = React.useState(deviceNames[0])

    // const activeIndex = React.useMemo(
    //     () => desktopData.findIndex((item) => item.month === activeMonth),
    //     [activeMonth]
    // )
    // const months = React.useMemo(() => deviceNames.map((item) => item), [])

    return (
        <Card className="flex flex-col">
            <CardHeader className="flex items-center gap-2 space-y-0 border-b py-3 sm:flex-row">
                {/* <div className="grid flex-1 gap-1 text-center sm:text-left">
                    <CardTitle>Pie Chart - Donut with Text</CardTitle>
                    <CardDescription>January - June 2024</CardDescription>
                </div> */}
                <div className="grid flex-1 gap-1 justify-end text-center sm:text-left">
                    <Select value={donutDeviceName} onValueChange={setDonutDeviceName}>
                        <SelectTrigger
                            className="ml-auto h-7 w-[130px] rounded-lg pl-2.5"
                            aria-label="Select a value"
                        >
                            <SelectValue placeholder="Select month" />
                        </SelectTrigger>
                        <SelectContent align="end" className="rounded-xl">
                            {deviceNames.map((key) => {
                                //   const config = chartConfig[key]

                                //   if (!config) {
                                //     return null
                                //   }

                                return (
                                    <SelectItem
                                        key={key}
                                        value={key}
                                        className="rounded-lg [&_span]:flex"
                                    >
                                        <div className="flex items-center gap-2 text-xs">
                                            {/* <span
                      className="flex h-3 w-3 shrink-0 rounded-sm"
                      style={{
                        backgroundColor: `var(--color-${key})`,
                      }}
                    /> */}
                                            {key}
                                        </div>
                                    </SelectItem>
                                )
                            })}
                        </SelectContent>
                    </Select>
                </div>
            </CardHeader>
            <CardHeader className="flex items-end pb-0">
                <CardTitle>{donutDeviceName}</CardTitle>
                <CardDescription>{chartDescription}</CardDescription>
            </CardHeader>
            <CardContent className="flex-1 pb-0">
                <ChartContainer
                    config={chartConfig}
                    className="mx-auto aspect-square max-h-[245px]"
                >
                    <PieChart>
                        <ChartTooltip
                            cursor={false}
                            content={<ChartTooltipContent hideLabel />}
                        />
                        <Pie
                            data={desktopData}
                            dataKey="desktop"
                            nameKey="month"
                            innerRadius={60}
                            strokeWidth={5}
                        >
                            <Label
                                content={({ viewBox }) => {
                                    if (viewBox && "cx" in viewBox && "cy" in viewBox) {
                                        return (
                                            <text
                                                x={viewBox.cx}
                                                y={viewBox.cy}
                                                textAnchor="middle"
                                                dominantBaseline="middle"
                                            >
                                                <tspan
                                                    x={viewBox.cx}
                                                    y={viewBox.cy}
                                                    className="fill-foreground text-3xl font-bold"
                                                >
                                                    {currentWeekValue.toLocaleString("en-US")}
                                                </tspan>
                                                <tspan
                                                    x={viewBox.cx}
                                                    y={(viewBox.cy || 0) + 24}
                                                    className="fill-muted-foreground"
                                                >
                                                בשבוע החולף
                                                </tspan>
                                            </text>
                                        )
                                    }
                                }}
                            />
                        </Pie>
                    </PieChart>
                </ChartContainer>
            </CardContent>
            <CardFooter className="flex-col gap-1 text-sm">
                <div className="flex flex-row flex-wrap gap-1 font-medium leading-none">
                    <div>
                        שחלף
                    </div>
                    <div>
                        בשבוע
                    </div>
                    <div>
                        { weeklyDifference < 0 ? (weeklyDifference*-1).toLocaleString("en-US"):weeklyDifference.toLocaleString("en-US") }
                    </div>
                    <div>
                        { differenceIsPercent ? "%":"" }
                    </div>
                    <div>
                        של
                    </div>
                    <div>
                        { weeklyDifference < 0 ? "ירידה":"עליה" }
                    </div>
                    <div>
                        מגמת
                    </div>
                    <div>
                        { weeklyDifference < 0 ? <TrendingDown className="h-4 w-4" /> : <TrendingUp className="h-4 w-4" /> }
                    </div>
                </div>
                <div className="leading-none text-muted-foreground">
                    בהשוואה לשבוע שלפני השבוע שחלף
                </div>
            </CardFooter>
        </Card>
    )
}